import tinycolor from "tinycolor2";
import { brand } from "./colors";
var isColorLight = function (color) { return tinycolor(color).isLight() && !(color === brand.default); };
export default isColorLight;
